<template>
	<div :class="['input', { 'has-error': errorMessage.length > 0 }]">
		<input
			:class="[{ filled: filled }]"
			:type="type"
			:value="modelValue"
			:id="id"
			:required="required"
			maxlength="4"
			ref="VInput"
			@input="$emit('update:modelValue', $event.target.value)"
		/>
		<label :for="id">{{ label }}</label>
		<img class="captcha-image" :src="captchaImageUrl" />
		<button
			@click="$emit('reloadCaptcha')"
			:disabled="isPosting"
			class="captcha-reload"
			type="button"
		>
			<img src="images/reload.png" />
		</button>
		<div v-for="(error, i) in errorMessage" :key="i">
			<small class="d-block">
				{{ error }}
			</small>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			filled: false,
		};
	},
	props: {
		type: {
			type: String,
			required: false,
			default: 'text',
		},
		id: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		modelValue: {
			type: String,
			required: false,
		},
		required: {
			type: Boolean,
			required: false,
			default: false,
		},
		errorMessage: {
			type: Array,
			required: false,
			defalut: [],
		},
		captchaImageUrl: {
			type: String,
			required: true,
		},
	},
	methods: {
		isFilled() {
			if (this.modelValue && this.modelValue.length > 0)
				this.filled = true;
			else this.filled = false;
		},
	},
	computed: {
		...mapGetters(['isPosting']),
	},
	mounted() {
		this.isFilled();
	},
	updated() {
		this.isFilled();
	},
};
</script>

<style>
.captcha-reload {
	background: none;
	border: 0 none;
	position: absolute;
	top: 8.5px;
	right: 1px;
	padding: 5px;
}

.captcha-reload img {
	width: 30px;
}

.captcha-image {
	position: absolute;
	top: 14px;
	right: 40px;
	width: 80px;
	height: 30px;
}
</style>
